var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPasswordIconUnlock = function SvgPasswordIconUnlock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 7,
    width: 13,
    height: 12,
    rx: 2,
    fill: "#2576FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 3h4v1.186h2.5V2.5a2 2 0 0 0-2-2h-5a2 2 0 0 0-2 2v6H13V3Z",
    fill: "#2576FF"
  })));
};

export default SvgPasswordIconUnlock;